/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_SavedInputs */

const en_us2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note saved`)
};

const pt_br2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota salva`)
};

const es_419_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota guardada`)
};

const pt_pt2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota guardada`)
};

const fr_fr2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note enregistrée`)
};

const de_de2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz gespeichert`)
};

const it_it2_exercise_personal_note_saved = /** @type {(inputs: Exercise_Personal_Note_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota salvata`)
};

/**
* | output |
* | --- |
* | "Note saved" |
*
* @param {Exercise_Personal_Note_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_saved = /** @type {((inputs?: Exercise_Personal_Note_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_saved(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_saved(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_saved(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_saved(inputs)
	return en_us2_exercise_personal_note_saved(inputs)
});
export { exercise_personal_note_saved as "exercise-personal.note_saved" }